import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { store, history } from './store/index'

import Main from './components/Main'

render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Main />
        </ConnectedRouter >
    </Provider>,
    document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js